import { render, staticRenderFns } from "./UnderConstructionLoader.vue?vue&type=template&id=29232866&scoped=true&"
import script from "./UnderConstructionLoader.vue?vue&type=script&lang=js&"
export * from "./UnderConstructionLoader.vue?vue&type=script&lang=js&"
import style0 from "./UnderConstructionLoader.vue?vue&type=style&index=0&id=29232866&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29232866",
  null
  
)

export default component.exports